import React from 'react';
import { Box, Typography } from '@mui/material';
import { CalendarToday } from '@mui/icons-material';

/**
 * Upload date template with icon
 */
export const UploadDateTemplate: React.FC<{ uploadDateFormatted: string }> = ({
  uploadDateFormatted,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
    <CalendarToday sx={{ fontSize: 14, color: '#64748b' }} />
    <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
      {uploadDateFormatted}
    </Typography>
  </Box>
);

export default UploadDateTemplate;
